import { createFileRoute } from '@tanstack/react-router';
import { AdminPlanPage } from '../../features/billing';

export const Route = createFileRoute('/admin/plans/$id')({
  component: function PlanRoute() {
    const { id } = Route.useParams();
    return <AdminPlanPage id={id} />;
  },
});
